import React, { FunctionComponent, PropsWithChildren } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../ErrorFallback";

type Props = PropsWithChildren<{}>;

/**
 * Renders an error boundary that catches errors in its child components
 * and displays the standard Spintr fallback UI.
 *
 * @param {Props} props - The component props.
 * @param {ReactNode} props.children - The child components to render.
 * @returns {JSX.Element} The rendered error boundary component.
 */
function StandardErrorBoundary({ children }: Props): JSX.Element {
    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            {children}
        </ErrorBoundary>
    );
}

export default StandardErrorBoundary;

